import { cn } from "@core/utils/cn";
import type { ComponentProps } from "react";
import type { IconType } from "react-icons";

type SideBarBtnProps = ComponentProps<"button"> & {
  icon?: IconType | string;
  iconPosition?: "left" | "right";
  text: string;
  action?: () => void;
  collapsed?: boolean;
};

const SideBarBtn = ({
  text,
  className,
  icon: Icon,
  iconPosition = "left",
  action,
  collapsed = false,
  ...props
}: SideBarBtnProps) => {
  if (collapsed) {
    return (
      <button
        type="button"
        onClick={action}
        title={text}
        aria-label={text}
        className={cn(
          "relative flex items-center justify-center w-11 h-11 rounded-lg cursor-pointer transition-all duration-200 ease-in-out focus:outline-none",
          "text-neutral-300 hover:bg-surface-hover/50 hover:text-neutral-950",
          className,
        )}
        {...props}
      >
        {Icon && <Icon className="shrink-0 text-xl" />}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={action}
      className={cn(
        "relative flex items-center gap-2 h-[2.4375rem] px-2 rounded w-full cursor-pointer font-medium transition-all duration-200 ease-in-out focus:outline-none overflow-hidden",
        "text-neutral-300 hover:bg-surface-hover/50 hover:text-neutral-950",
        className,
      )}
      {...props}
    >
      {Icon && iconPosition === "left" && <Icon className="shrink-0 text-xl" />}
      <span className="text-sm capitalize whitespace-nowrap">{text}</span>
      {Icon && iconPosition === "right" && (
        <Icon className="shrink-0 text-xl" />
      )}
    </button>
  );
};

export default SideBarBtn;
